import { Banner, Text } from '@dixa/lib-shared-habla';

import styles from './formInfoBanner.module.scss';

export function FormInfoBanner(): JSX.Element {
  return (
    <Banner
      className={styles.root}
      variant="info"
      description={
        <Text.Paragraph variant="4">
          When the form is integrated with an external endpoint or used as a
          terminal node in a messenger, its name will be used as the subject for
          follow-up emails.
        </Text.Paragraph>
      }
    />
  );
}
